module.exports = __webpack_public_path__ + "img/changeTime.45f444dc.svg";